export const GROUP_TIMELINE_FILTER_MENU_WIDTH = 340;
export const GROUP_TIMELINE_FILTER_VIEW_PAD = 8;

export function placeGroupTimelineFilterMenu(
  trigger: Pick<DOMRect, 'left' | 'right' | 'top' | 'bottom'>,
  viewport: { width: number; height: number },
  menuHeight?: number,
): { top: number; left: number; width: number; maxHeight: number } {
  const pad = GROUP_TIMELINE_FILTER_VIEW_PAD;
  const width = Math.min(GROUP_TIMELINE_FILTER_MENU_WIDTH, viewport.width - pad * 2);
  let left = trigger.right - width;
  if (left < pad) left = trigger.left;
  left = Math.min(Math.max(pad, left), viewport.width - width - pad);

  const spaceBelow = viewport.height - trigger.bottom - pad;
  const spaceAbove = trigger.top - pad;
  const preferred = Math.min(560, Math.round(viewport.height * 0.7));
  const openBelow = spaceBelow >= Math.min(220, preferred) || spaceBelow >= spaceAbove;
  const maxHeight = Math.max(160, Math.min(preferred, openBelow ? spaceBelow : spaceAbove));
  const top = openBelow
    ? trigger.bottom + 4
    : Math.max(pad, trigger.top - (menuHeight || maxHeight) - 4);
  return { top, left, width, maxHeight };
}
